import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87beac76"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Dashboard")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Users")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Vi", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "En", -1))
const _hoisted_6 = { href: "/#/pos" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("POS ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CHeaderToggler = _resolveComponent("CHeaderToggler")!
  const _component_CHeaderBrand = _resolveComponent("CHeaderBrand")!
  const _component_CNavLink = _resolveComponent("CNavLink")!
  const _component_CNavItem = _resolveComponent("CNavItem")!
  const _component_CHeaderNav = _resolveComponent("CHeaderNav")!
  const _component_CFormCheck = _resolveComponent("CFormCheck")!
  const _component_CButtonGroup = _resolveComponent("CButtonGroup")!
  const _component_AppHeaderDropdownAccnt = _resolveComponent("AppHeaderDropdownAccnt")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CContainer = _resolveComponent("CContainer")!
  const _component_CHeaderDivider = _resolveComponent("CHeaderDivider")!
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_CHeader = _resolveComponent("CHeader")!

  return (_openBlock(), _createBlock(_component_CHeader, {
    position: "sticky",
    class: "mb-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CContainer, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_CHeaderToggler, {
            class: "ps-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('toggleSidebar')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, {
                icon: "cil-menu",
                size: "lg"
              })
            ]),
            _: 1
          }),
          false
            ? (_openBlock(), _createBlock(_component_CHeaderBrand, {
                key: 0,
                class: "mx-auto d-lg-none",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CIcon, {
                    icon: $setup.logo,
                    height: "48",
                    alt: "Logo"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_CHeaderNav, { class: "d-none d-md-flex me-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_CNavItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CNavLink, { href: "/dashboard" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CNavItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CNavLink, { href: "#" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CNavItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CNavLink, { href: "#" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!$data.isTool)
            ? (_openBlock(), _createBlock(_component_CHeaderNav, {
                key: 1,
                class: "ms-auto me-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CButtonGroup, { "aria-label": "Lang switch" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CFormCheck, {
                        type: "radio",
                        button: { color: 'light' },
                        name: "vi-switch",
                        id: "btn-vi",
                        autoComplete: "off",
                        checked: $data.lang === 'vi',
                        onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.langChange('vi')))
                      }, {
                        label: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_CFormCheck, {
                        type: "radio",
                        button: { color: 'light' },
                        name: "en-switch",
                        id: "btn-en",
                        autoComplete: "off",
                        checked: $data.lang === 'en',
                        onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.langChange('en')))
                      }, {
                        label: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock(_component_CHeaderNav, {
                key: 2,
                class: "ms-auto me-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CButtonGroup, { "aria-label": "Theme switch" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CFormCheck, {
                        type: "radio",
                        button: { color: 'primary' },
                        name: "theme-switch",
                        id: "btn-light-theme",
                        autoComplete: "off",
                        checked: _ctx.$store.state.theme === 'default',
                        onChange: _cache[3] || (_cache[3] = 
              (event) =>
                _ctx.$store.commit({
                  type: 'toggleTheme',
                  value: 'default',
                })
            )
                      }, {
                        label: _withCtx(() => [
                          _createVNode(_component_CIcon, { icon: "cil-sun" })
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_CFormCheck, {
                        type: "radio",
                        button: { color: 'primary' },
                        name: "theme-switch",
                        id: "btn-dark-theme",
                        autoComplete: "off",
                        checked: _ctx.$store.state.theme === 'dark',
                        onChange: _cache[4] || (_cache[4] = 
              (event) =>
                _ctx.$store.commit({
                  type: 'toggleTheme',
                  value: 'dark',
                })
            )
                      }, {
                        label: _withCtx(() => [
                          _createVNode(_component_CIcon, { icon: "cil-moon" })
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!$data.isTool)
            ? (_openBlock(), _createBlock(_component_CHeaderNav, {
                key: 3,
                class: "ms-3 me-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppHeaderDropdownAccnt)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_CHeaderNav, { class: "ms-3 me-4" }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_CButton, {
                  size: "sm",
                  color: "primary",
                  style: {"font-weight":"bold"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CHeaderDivider),
      (!$data.isTool)
        ? (_openBlock(), _createBlock(_component_CContainer, {
            key: 0,
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppBreadcrumb)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}